/** Nombre comercial de la agencia en los textos de la tienda (interaction.md: `{agencia}`, pendiente de definir). */
export const AGENCIA = "tu agencia";
